var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',{attrs:{"type":"checkbox","label":_vm.label,"label-position":"before","disabled":_vm.disabled},model:{value:(_vm.input_value),callback:function ($$v) {_vm.input_value=$$v},expression:"input_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }